import parse from "html-react-parser"

import iconChevron from "images/layout/chevron-down.svg?raw"

import styles from "./select_input.module.scss"

export type SelectInputOption = {
  value: string
  label: string
}

interface Props {
  value: string
  options: SelectInputOption[]
  onChange: (value: string) => void
  ariaLabel: string
  disabled?: boolean
}

export const SelectInput = ({ value, options, onChange, ariaLabel, disabled }: Props) => (
  <span className={styles["wrap"]}>
    <select
      className={styles["select"]}
      value={value}
      aria-label={ariaLabel}
      disabled={disabled}
      onChange={event => onChange(event.target.value)}
    >
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
    <span className={styles["chevron"]} aria-hidden="true">
      {parse(iconChevron)}
    </span>
  </span>
)
